<script setup>
/**
 * FormControlUsersRoles
 * A relationship control for assigning roles to a user.
 * This component is hidden if the user is an administrator, as roles do not apply to them.
 */
import { computed, watchEffect } from 'vue';
import FormControlTypeRelationshipManyToMany from '@/common/form-control-type/FormControlTypeRelationshipManyToMany.vue';

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
});

const administrator = computed(() => parseInt(props.currentData.administrator));

// Use watchEffect to reactively toggle visibility based on the administrator status.
watchEffect(() => {
    // The field should be hidden if the user is an administrator (value is 1)
    props.field.visibility = administrator.value ? 'hidden' : '';
});
</script>

<template>
    <FormControlTypeRelationshipManyToMany
        :form-id="formId"
        :field="field"
        :current-data="currentData"
    />
</template>